<template>
  <div class="px-4 py-12 text-women-text max-w-680">
    <h1 class="mb-3 o-heading-1" v-text="getTranslation('Sizechart.BraSizePage.Title')" />
    <p class="mb-10 o-body" v-html="getTranslation('Sizechart.BraSizePage.Description')" />
    <p class="mb-3 o-heading-3" v-html="getTranslation('Sizechart.BraSizePage.BottomSide')" />
    <div class="md:flex mb-6">
      <div class="mb-6 md:mb-0">
        <OImage
          v-bind="imageOne"
          img-class="rounded max-w-full"
          :alt="$t('Accessibilty.AltTags.WomenProductImage')"
        />
      </div>
      <div class="md:pl-6">
        <p class="mb-3 o-heading-4" v-html="getTranslation('Sizechart.BraSizePage.StepOne.Title')" />
        <p class="mb-3 o-body" v-html="getTranslation('Sizechart.BraSizePage.StepOne.Description')" />
      </div>
    </div>
    <p class="mb-3 o-heading-3" v-html="getTranslation('Sizechart.BraSizePage.CupSize')" />
    <div class="md:flex mb-6">
      <div class="mb-6 md:mb-0">
        <OImage
          v-bind="imageTwo"
          img-class="rounded max-w-full"
          :alt="$t('Accessibilty.AltTags.WomenProductImage')"
        />
      </div>
      <div class="md:pl-6">
        <p class="mb-3 o-heading-4" v-html="getTranslation('Sizechart.BraSizePage.StepTwo.Title')" />
        <p class="mb-3 o-body" v-html="getTranslation('Sizechart.BraSizePage.StepTwo.Description')" />
      </div>
    </div>
    <div class="my-10 h-px bg-neutral-400" />
    <p class="mb-3 o-heading-4" v-html="getTranslation('Sizechart.BraSizePage.StepThree.Title')" />
    <p class="mb-3 o-body" v-html="getTranslation('Sizechart.BraSizePage.StepThree.Description')" />
    <BraSizeChart :sizechart-zone="sizechartZone" />
    <p class="mt-3 o-body" v-text="getTranslation('Sizechart.BraSizePage.InchToCm')" />
    <div class="my-10 h-px bg-neutral-400" />
    <p class="mb-3 o-heading-4" v-html="getTranslation('Sizechart.BraSizePage.StepFour.Title')" />
    <p class="mb-3 o-body" v-html="getTranslation('Sizechart.BraSizePage.StepFour.Description')" />
    <TopSizeChart table-class="table-fixed" :sizechart-zone="sizechartZone" />
    <div class="my-10 h-px bg-neutral-400" />
    <template v-if="!isAuthenticated">
      <p class="mb-3 o-body" v-html="getTranslation('Sizechart.BraSizePage.GoodToGo')" />
      <NewButton tag="nuxt-link" to="/women/signup" icon-right="new-chevron-right" color="women">
        {{ getTranslation('Sizechart.BraSizePage.TryForFree') }}
      </NewButton>
    </template>
  </div>
</template>

<script>
import { SizechartZonesCountryMap } from '@/enums/sizechart'
import { IS_AUTHENTICATED } from '@/utils/store/getterTypes'
import { mapState, mapGetters } from 'vuex'
import BraSizeChart from '@/components/Women/BraSizeChart'
import TopSizeChart from '@/components/Women/TopSizeChart'
import NewButton from '@/components/NewButton'
import OImage from '@/components/OImage'
import { getImagePaths } from '@/utils/general'
import { TrialDuration } from '@/enums/member'

export default {
  name: 'WomenBraSize',
  layout: 'homepage',
  components: { BraSizeChart, NewButton, OImage, TopSizeChart },
  data () {
    return {
      sizechartZone: SizechartZonesCountryMap.nl
    }
  },
  computed: {
    imageOne () {
      return getImagePaths({ path: '/images/frontend/static/measure-1', s3: true })
    },
    variables () {
      return {
        trialDuration: TrialDuration[this.country]
      }
    },
    imageTwo () {
      return getImagePaths({ path: '/images/frontend/static/measure-2', s3: true })
    },
    ...mapState('app', {
      country: state => state.country
    }),
    ...mapGetters('auth', {
      isAuthenticated: IS_AUTHENTICATED
    })
  },
  watch: {
    country: {
      immediate: true,
      handler (newC) {
        if (this.sizechartZone !== SizechartZonesCountryMap[newC]) {
          this.sizechartZone = SizechartZonesCountryMap[newC]
        }
      }
    }
  },
  methods: {
    getTranslation (path = '') {
      return this.$t(path, this.variables)
    }
  }
}
</script>

<style scoped lang="postcss">
.max-w-680 {
  @apply mx-auto;
  max-width: 68rem;
}

.oimage >>> img {
  max-width: 100% !important;
}

@screen md {
  .oimage >>> img {
    max-width: unset !important;
  }
}
</style>
